import { Form, Input, Row, Col, Switch, Select } from 'antd';
import { useEffect, useRef, useState } from 'react';
import WebEditUniversal, { WebEditUniversalProps } from '../../system/WebEditUniversal';
import getList from '../../../utilsTsx/universal/getList';
import fetchApi from '../../../utilsTsx/components/system/fetchApi';
import WangeditorV5ForAntD from '../../../utilsTsx/components/wangeditor/WangeditorV5ForAntD';

const WebProductEdit = (props: any) => {
    const [form] = Form.useForm(); //form 
    const { defaultService } = props;
    const ref = useRef<any>(undefined);
    const [brandData, setBrandData] = useState<any>();
    const [productTypeData, setProductTypeData] = useState<any>();
    const [shopData, setShopData] = useState<any>();
    const [id, setId] = useState<string>();

    useEffect(() => {
        ref.current.getRow.then((res: any) => {
            if (res.success) {
                setId(res?.data?.id);
            }
        })
        fetchApi.GET(defaultService,
            {
                query: {
                    apiId: 'webProductType',
                    apiExtend: 'showList'
                }
            }).then(res => {
                if (res.success) {
                    setProductTypeData(res.data);
                }
            });
        fetchApi.GET(defaultService,
            {
                query: {
                    apiId: 'brand',
                    apiExtend: 'showList'
                }
            }).then(res => {
                if (res.success) {
                    setBrandData(res.data)
                }
            });
        fetchApi.GET(defaultService,
            {
                query: {
                    apiId: 'shop',
                    apiExtend: 'showList'
                }
            }).then(res => {
                if (res.success) {
                    setShopData(res.data);
                }
            });
    }, []);

    const extendProps: WebEditUniversalProps = {
        ...props,
        apiId: 'webProduct',
        displayOptions: {
            width: 1080
        },
        formOptions: {
            instance: form,
            children: (
                <Row gutter={[8, 0]}>
                    {/* ---------- 左半边：原来的表单 ---------- */}
                    <Col span={8}>
                        <Row gutter={[8, 0]}>
                            <Col span={24}>
                                <Form.Item label="id" name="id">
                                    <Input disabled={true} />
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Form.Item
                                    label="名称"
                                    name="productName"
                                    rules={[{ required: true, message: '产品名称!' }]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Form.Item
                                    label="品牌"
                                    name="brandId"
                                    rules={[{ required: true, message: '品牌!' }]}
                                >
                                    <Select
                                        showSearch
                                        placeholder="品牌"
                                        optionFilterProp="children"
                                        filterOption={(input, option: any) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        {getList.general(brandData, { itemName: 'brandName' })}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Form.Item
                                    label="店铺"
                                    name="shopId"
                                    rules={[{ required: true, message: '店铺!' }]}
                                >
                                    <Select
                                        showSearch
                                        placeholder="店铺"
                                        optionFilterProp="children"
                                        filterOption={(input, option: any) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        {getList.general(shopData, { itemName: 'shopName' })}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Form.Item
                                    label="分类"
                                    name="productTypeId"
                                    rules={[{ required: true, message: '产品分类!' }]}
                                >
                                    <Select
                                        showSearch
                                        placeholder="产品分类"
                                        optionFilterProp="children"
                                        filterOption={(input, option: any) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        {getList.general(productTypeData, { itemName: 'typeName' })}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Form.Item label="广告词" name="advertising">
                                    <Input.TextArea placeholder="广告词" rows={10} />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item label="月销量" name="monthlyQuantitySold">
                                    <Input disabled={true} />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="广告"
                                    name="isAd"
                                    valuePropName="checked"
                                    initialValue={true}
                                >
                                    <Switch checked={true} checkedChildren="启用" unCheckedChildren="关闭" />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="状态"
                                    name="isUse"
                                    valuePropName="checked"
                                    initialValue={true}
                                >
                                    <Switch checked={true} checkedChildren="启用" unCheckedChildren="关闭" />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Col>

                    {/* ---------- 右半边：你要放的其他内容 ---------- */}
                    <Col span={16}>
                        {/* 这里可以自由添加表单项或其他组件 */}
                        <Form.Item
                            label=""
                            name="details">
                            <WangeditorV5ForAntD
                                key={id}
                                id={`webProduct${id}`}
                                displayMode="editor"
                                defaultService={defaultService}
                                style={{ height: 500 }}
                            />
                        </Form.Item>
                    </Col>
                </Row>
            )
        }
    };
    return (<WebEditUniversal ref={ref} {...extendProps} />)
}

export default WebProductEdit;